import { LocalDate, MilestoneBubbleType } from '../../../models';
import { BorderType } from '../../../../common/constants/border-type';

export interface SpecialFreightMilestoneModel {
  address: string;
  bubbleType: MilestoneBubbleType;
  description: string;
  linkType: BorderType;
  plannedDateTime: LocalDate;
  title: string;
}
